module.exports = __webpack_public_path__ + "media/images/header_icons/question-82b77be6875e4e8843d01b9e8dd4befd.svg";